<template>
  <div class="icon-container">
    <!-- 显示element-ui中的icon -->
    <el-icon v-if="iconClass && iconClass.startsWith('el-icon-')">
      <component :is="iconClass.slice(8)" :style="sizeStyle" />
    </el-icon>

    <!-- 显示svg -->
    <svg-icon v-else-if="iconClass" :icon-class="iconClass" :style="sizeStyle" />
  </div>
</template>

<script>
/**
 * 通用icon 可用element和svg-icon
 */
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Icon',
  props: {
    iconClass: {
      type: String,
      default: ''
    },
    size: {
      type: [String, Number],
      default: 14
    }
  },
  computed: {
    /**
     * 大小样式
     */
    sizeStyle() {
      let size = ''
      if (isNaN(this.size)) {
        size = this.size
      } else {
        size = `${this.size}px`
      }
      return {
        width: size,
        height: size
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-container {
  display: inline-flex;
  line-height: 1;

  :deep(.el-icon) {
    width: initial;
    height: initial;
  }
}
</style>
